import {readString} from 'react-papaparse';

import {MAX_RECORDS} from './constants';

export const parseAccountsFile = (file: File): Promise<{accountName?: string, accountId?: number}[]> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = event => {
            if (event.target) {
                const fileContent = event.target.result as string;
                readString(fileContent, {
                    header: false,
                    dynamicTyping: true,
                    delimiter: ',',
                    skipEmptyLines: true,
                    quoteChar: '"',
                    complete: results => {
                        if (results.errors.length > 0) {
                            reject(results.errors);
                        } else {
                            const data = results.data as (string | number)[][];

                            const headers = data[0]
                                .map(header => (header === null ? '' : header))
                                .map((header: string | number) => header.toString().toLowerCase().trim());
                            const accountNameIndex = headers.indexOf('account name');
                            const accountIdIndex = headers.indexOf('id');

                            const records: {accountName?: string, accountId?: number}[] = [];

                            data.slice(1).forEach(row => {
                                if (accountNameIndex !== -1 && accountIdIndex !== -1) {
                                    const accountName = row[accountNameIndex] === null
                                        ? ''
                                        : row[accountNameIndex].toString().trim();
                                    const accountId = row[accountIdIndex] === null
                                        ? 0
                                        : +row[accountIdIndex];

                                    if (accountId) {
                                        records.push({accountId});
                                    } else if (accountName) {
                                        records.push({accountName});
                                    }
                                }
                            });

                            if (records.length) {
                                resolve(records);
                            } else {
                                reject(new Error(
                                    'File does not contain records with required Account Name or ID columns.',
                                ));
                            }
                        }
                    },
                });
            } else {
                reject(new Error('Event target is null.'));
            }
        };

        reader.onerror = error => {
            reject(error);
        };

        reader.readAsText(file);
    });
};

export const validateAccountsFile = (file: File): Promise<boolean> => {
    return new Promise((resolve, reject) => {

        if (file.type !== 'text/csv') {
            reject(new Error('Invalid file type. Please upload a CSV file.'));
        }
        const reader = new FileReader();
        reader.onload = event => {
            if (event.target) {
                const fileContent = event.target.result as string;
                readString(fileContent, {
                    header: false,
                    dynamicTyping: true,
                    delimiter: ',',
                    skipEmptyLines: true,
                    quoteChar: '"',
                    complete: results => {
                        if (results.errors.length > 0) {
                            reject(results.errors);
                        } else {
                            if (!results.data.length) {
                                reject(new Error('The uploaded file cannot be empty.'));
                            }

                            const data = results.data as (string | number)[][];

                            const headers = data[0]
                                .filter(header => header !== null)
                                .map((header: (string | number)) => header.toString().toLowerCase());

                            if (headers.includes('account name') || headers.includes('id')) {
                                if (results.data.length > MAX_RECORDS + 1) {
                                    reject(new Error(`The file contains more than ${MAX_RECORDS} records.`));
                                }

                                if (results.data.length === 1) {
                                    reject(new Error('The uploaded file cannot be empty.'));
                                } else {
                                    resolve(true);
                                }
                            } else {
                                reject(new Error('File does not contain required Account Name or ID columns.'));
                            }
                        }
                    },
                });
            } else {
                reject(new Error('Event target is null.'));
            }
        };

        reader.onerror = error => {
            reject(error);
        };

        reader.readAsText(file);
    });
};
